import Layout from '@/components/layout/Layout';
import { PaymentCardInputContent } from '@/components/tax-refund/payment-card/PaymentCardInputContent';

function PaymentCardInputPage() {
  return (
    <Layout leftIcon={{ icon: 'back' }}>
      <PaymentCardInputContent />
    </Layout>
  );
}

export default PaymentCardInputPage;
